<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  {...rest}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5 5.5C7.79688 5.5 5.16624 7.15858 4.60822 9.72923C3.94576 10.5253 2.95624 11 1.89703 11H1L1.35566 10.4665C1.75902 9.86147 1.83865 9.09663 1.56859 8.42147L1.55709 8.39272C1.18908 7.47269 1 6.4909 1 5.5C1 3.01472 3.46243 1 6.5 1C9.53757 1 12 3.01472 12 5.5C12 5.55665 11.9987 5.61306 11.9962 5.66921C11.5087 5.55803 11.0056 5.5 10.5 5.5ZM6 10.75C6 12.8211 8.01472 14.5 10.5 14.5C11.1322 14.5 11.7339 14.3914 12.2798 14.1953C13.0797 14.7139 14.0221 15 15 15L14.3795 14.0693C14.1497 13.7245 14.1497 13.2755 14.3795 12.9307L14.4453 12.8321C14.807 12.2895 15 11.6521 15 11H14.9902C14.9967 10.9174 15 10.834 15 10.75C15 8.67893 12.9853 7 10.5 7C8.01472 7 6 8.67893 6 10.75Z"
    fill="currentColor"
  />
</svg>
